module.exports = __webpack_public_path__ + "img/nest.b90f6476.png";